export default __webpack_public_path__ + "static/media/PropostasPendentes.39e546e1.svg";